import React, { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ActionIcon } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { useFirebaseDatabaseRootData } from "../../../context/FirebaseDatabaseRootDataContext";
import ProjectHero from "./ProjectHero";
import ProjectGallery from "./ProjectGallery";
import ProjectNavigation from "./ProjectNavigation";
import "./ProjectPage.css";

const ProjectDetailView = ({ project, onBack }) => {
  const navigate = useNavigate();
  const handleBack = onBack || (() => navigate("/#projects"));

  return (
    <div className="project-page-container">
      <div className="project-page-content">
        <ActionIcon
          className="back-button"
          variant="transparent"
          onClick={handleBack}
          aria-label="Go back"
        >
          <IconArrowLeft size={24} />
        </ActionIcon>
        
        <ProjectHero project={project} />
        <ProjectGallery project={project} />
        <ProjectNavigation currentProjectId={project.id} />
      </div>
    </div>
  );
};

const ProjectPage = ({ project: projectProp, onBack }) => {
  const { projectId } = useParams();
  const { rootData, rootDataLoading, rootDataError } =
    useFirebaseDatabaseRootData();

  const project = useMemo(() => {
    if (projectProp) return projectProp;
    if (rootData?.projects && projectId) {
      return rootData.projects.find((p) => p.id === projectId);
    }
    return null;
  }, [rootData, projectId, projectProp]);

  if (rootDataLoading) {
    return <div className="project-page-status">Loading project details...</div>;
  }

  if (rootDataError) {
    return <div className="project-page-status error">Error: {rootDataError}</div>;
  }

  if (!project) {
    return <div className="project-page-status">Project not found!</div>;
  }

  return <ProjectDetailView project={project} onBack={onBack} />;
};

export default ProjectPage;